module.exports = __webpack_public_path__ + "static/img/conium.5c182b8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/partnerships/conium.jpg
// module id = U/IJ
// module chunks = 1